/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";

import Dropdown from "react-bootstrap/Dropdown";
import { useSelector } from "react-redux";

import { DropdownMenu4 } from "../../../../_partials/dropdowns";
import { DropdownTopbarItemToggler } from "../../../../_partials/dropdowns";

export function UserProfileDropdown() {
  const { user, orgLogos } = useSelector((state) => state.auth);
  const orgLogo = orgLogos?.[user?.organization];

  return (
    <Dropdown drop="down" alignRight>
      <Dropdown.Toggle
        as={DropdownTopbarItemToggler}
        id="dropdown-toggle-user-profile"
      >
        <div
          className={
            "btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2"
          }
        >
          <span className="text-muted font-weight-bold font-size-base d-none d-md-inline mr-1">
            Hi,
          </span>{" "}
          <span className="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3">
            {`${user.firstName} ${user.lastName}`}
          </span>
          <span className="symbol symbol-35 symbol-light-success">
            {orgLogo ? (
              <img
                src={orgLogo}
                alt="org logo"
                style={{ width: 35, height: 35, objectFit: 'contain', borderRadius: 4 }}
              />
            ) : (
              <span className="symbol-label font-size-h5 font-weight-bold">
                {user.firstName[0]}
              </span>
            )}
          </span>
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu className="p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-md">
        <DropdownMenu4 />
      </Dropdown.Menu>
    </Dropdown>
  );
}
